module.exports = __webpack_public_path__ + "static/media/9DESA29.1b2a5860.jpg";